export var IQQIframeData;
(function (IQQIframeData) {
    IQQIframeData["QFYF_SUCCESS"] = "login qfyf success";
    IQQIframeData["QQ_LOGIN_SUCCESS"] = "login qq success";
    IQQIframeData["QQ_OAUTH_LOGIN_SUCCESS"] = "login qq oauth success";
    IQQIframeData["QQ_BING_SUCCESS"] = "bind qq success";
    IQQIframeData["QQ_IFRAME_MOUNT"] = "mount qq iframe success";
})(IQQIframeData || (IQQIframeData = {}));
